import { render, staticRenderFns } from "./BladeMessage.vue?vue&type=template&id=f6c6d10a"
import script from "./BladeMessage.vue?vue&type=script&lang=js"
export * from "./BladeMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports